import { callBackendApi } from "../../../../components/service/axios";

export const patchGroupMembership = async (userGroupUniqueName, payload) => {
  return await callBackendApi(
    "patch",
    "/bff/user-groups/" + userGroupUniqueName + "/membership",
    payload
  );
};
